import {AfterViewInit, Directive, ElementRef, Input, Renderer2} from '@angular/core';

@Directive({
  selector: '[appSequentialAnimate]'
})
export class SequentialAnimateDirective implements AfterViewInit {
  @Input() direction: 'left' | 'right' | 'vertical' = 'vertical';
  @Input() stagger = 150; // in ms

  constructor(private el: ElementRef, private renderer: Renderer2) {
  }

  ngAfterViewInit() {
    const children = this.el.nativeElement.children;

    Array.from(children).forEach((child: HTMLElement, index: number) => {
      this.renderer.addClass(child, 'opacity-0');
      this.renderer.addClass(child, 'transition-all');
      this.renderer.addClass(child, 'duration-700');

      switch (this.direction) {
        case 'left':
          this.renderer.addClass(child, 'translate-x-[-40px]');
          break;
        case 'right':
          this.renderer.addClass(child, 'translate-x-[40px]');
          break;
        case 'vertical':
        default:
          this.renderer.addClass(child, 'translate-y-10');
          break;
      }

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              this.renderer.removeClass(child, 'opacity-0');
              this.renderer.addClass(child, 'opacity-100');

              this.renderer.removeClass(child, 'translate-x-[-40px]');
              this.renderer.removeClass(child, 'translate-x-[40px]');
              this.renderer.removeClass(child, 'translate-y-10');
            }, this.stagger * index);
          } else {
            this.renderer.removeClass(child, 'opacity-100');
            this.renderer.addClass(child, 'opacity-0');

            switch (this.direction) {
              case 'left':
                this.renderer.addClass(child, 'translate-x-[-40px]');
                break;
              case 'right':
                this.renderer.addClass(child, 'translate-x-[40px]');
                break;
              case 'vertical':
              default:
                this.renderer.addClass(child, 'translate-y-10');
                break;
            }
          }
        },
        {threshold: 0.1}
      );

      observer.observe(child);
    });
  }
}
